/* src/app/private/components/view/orgnization-package/orgnization-package.component.scss */
/*# sourceMappingURL=orgnization-package.component.css.map */
